/**
 * 汎用サービスエラー
 */
export class ServiceError extends Error {
    public status: number|undefined = undefined;

    constructor(message: string, status: number, options?: ErrorOptions) {
      super(message, options);
      this.status = status;
    }
  }
/**
 * 制限エラー
 */
export class ToManyError extends Error {
  public status: number|undefined = undefined;

  constructor(message: string, status: number, options?: ErrorOptions) {
    super(message, options);
    this.status = status;
  }
}
/**
 * バリデーションエラー
 */
export class ValidateError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message);
  }
}